<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <unit-form v-if="unit"
          @submit="submit"
          :init-unit="unit"
          :val-errors="valErrors"
          submit-text="Speichern"
        />
      </card>
    </div>
  </div>
</template>

<script>
import UnitForm from './unit-form'

export default {
  components: { UnitForm },
  data () {
    return {
      unit: null,
      valErrors: []
    }
  },
  methods: {
    async submit (unit) {
      await this.initCsrf()

      this.valErrors = []
      this.$http.put(`/units/${unit.id}`, unit).then(({ data }) => {
        this.$notify({
          message: 'Einheit erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/units')
      }).catch(({ response }) => { this.valErrors = response.data.errors })
    }
  },
  created () {
    this.$http.get(`/units/${this.$route.params.id}`).then(({ data }) => {
      this.unit = data
    })
  }
}
</script>

<style>
</style>
